export default __webpack_public_path__ + "static/media/codewars-logo.2142327c.svg";